import axios from 'axios'
import { api } from '@/services/config'
import { mixin } from '@/mixins/helper'
import router from '../../router'
import store from '@/store'

const notifStore = {
  namespaced: true,
  state: () => ({
    total_notif: 0,
    list: null,
    legal_doc: [],
    multi_modal: false,
    search_modal: false,

    vendorName: '',
    chooseSio: null,
    chooseMine: null,
    chooseK3lScore: [],
    chooseStatus: [],
    chooseExpire: [],
  }),
  mutations: {
    SET_NOTIFICATIONS_LIST(state, payload) {
      state.total_notif = payload.total
      state.list = payload.value
    },
    UPDATE_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    RESET_FILTER(state) {
      state.vendorName = ''
      state.chooseSio = null
      state.chooseMine = null
      state.chooseK3lScore = []
      state.chooseStatus = []
      state.chooseExpire = []
    },
  },
  actions: {
    getNotifWithLoading: async ({ commit, state, rootState }, payload) => {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/notification/${payload.id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('SET_NOTIFICATIONS_LIST', {
          value: data.data.notif,
          total: data.data.total,
        })
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },

    getNotifications: async ({ commit, state, rootState }, payload) => {
      const url = `${api}/api/v1/notification/${payload.id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('SET_NOTIFICATIONS_LIST', {
          value: data.data.notif,
          total: data.data.total,
        })
      } catch (error) {}
    },

    updateNotif: async ({ commit, dispatch, state, rootState }, payload) => {
      const url = `${api}/api/v1/notification/${payload.id}`
      let updateData = {}

      if (payload.status) {
        updateData = {
          last_open: payload.last_open,
        }
      } else {
        updateData = {
          is_open: true,
          open_by: payload.name,
          last_open: payload.last_open,
        }
      }

      try {
        const { data } = await axios({
          url,
          method: 'PUT',
          data: updateData,
        })

        if (data && data.status == 'success') {
          dispatch('getNotifications', { id: payload.role_id })
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },

    readAllNotif: async ({ commit, dispatch, state, rootState }, payload) => {
      const url = `${api}/api/v1/notification/read-all`
      let updateData = {}

      if (payload.status) {
        updateData = {
          last_open: payload.last_open,
        }
      } else {
        updateData = {
          is_open: true,
          open_by: payload.name,
          last_open: payload.last_open,
        }
      }

      try {
        const { data } = await axios({
          url,
          method: 'POST',
          data: updateData,
        })

        if (data && data.status == 'success') {
          dispatch('getNotifications', { id: payload.role_id })
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },

    checkDocument: async ({ commit, state, rootState }, payload) => {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const {
        vendorName,
        chooseSio,
        chooseMine,
        chooseK3lScore,
        chooseStatus,
        chooseExpire,
      } = state

      let allQuery = '?'

      if (vendorName && vendorName != '') {
        allQuery += `&vendor=${vendorName}`
      }
      if (chooseSio && chooseSio != '') {
        allQuery += `&sio=${chooseSio}`
      }
      if (chooseMine && chooseMine != '') {
        allQuery += `&mine=${chooseMine}`
      }
      if (chooseK3lScore && chooseK3lScore.length > 0) {
        let k3lFormat = mixin.methods.paramsFormatter('k3l', chooseK3lScore)
        allQuery += k3lFormat
      }
      if (chooseStatus && chooseStatus.length > 0) {
        let statusFormat = mixin.methods.paramsFormatter(
          'statusLegal',
          chooseStatus
        )

        allQuery += statusFormat
      }

      const url = `${api}/api/v1/request/document-check${allQuery}`
      state.legal_doc = []
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          if (data.data && data.data.length > 0) {
            let result = data.data
            let filterExpire = []
            if (chooseExpire && chooseExpire.length > 0) {
              function checkExpired(docs) {
                let count = 0

                for (let i in docs) {
                  if (docs[i].status == 'Expired') {
                    count += 1
                  }
                }

                if (count > 0) {
                  return 'Expired'
                }
                return 'Expired Soon'
              }

              for (let i in chooseExpire) {
                for (let j in result) {
                  if (chooseExpire[i] == checkExpired(result[j]['docs'])) {
                    filterExpire.push(result[j])
                  }
                }
              }
            } else {
              filterExpire = result
            }
            state.legal_doc = filterExpire
          }
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },

    createPqManual: async ({ commit, state, rootState, dispatch }, payload) => {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/pq-manual`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: payload,
        })

        await commit(
          'SET_NOTIF',
          `PQ Legal reminder telah dibuat untuk vendor ${payload.nama_vendor}, ${payload.alias_profile}`,
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
        await dispatch('checkDocument')
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },

    createMassPq: async ({ commit, state, rootState, dispatch }, payload) => {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/pq-mass-manual`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: payload,
        })

        if (data && data.status == 'success') {
          state.multi_modal = false
          await commit('SET_NOTIF', `PQ Legal reminder sedang dalam process`, {
            root: true,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
          await dispatch('checkDocument')
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
  },
}

export default notifStore
